import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import log01 from '../assets/img/logo.png';

function Privacypolicy() {

  // useEffect(()=>{
  //   document.title = 'Elixir | About Us';
  // }, []);

  return (
    <>
    <section className="innerPages">
      <Container>
        <div className="">
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box1">
                <h1>Elixir & AR <span>About Us</span></h1>
                <h4>We Print Securely, We Protect Strictly</h4>
              </div>
            </Col>
            <Col lg={6}>
              <div className="innerPages-box2">
                <div className="aboutPages-box2">
                  <img src={require('../assets/img/privacypolicy-page-banner-1.jpg')} className="img-fluid" alt="elixir" />
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <div className="innerPages-box3">
                <div className="aboutPages-logo">
                  <h4>Leading Company</h4>
                  <img id="one" src={log01} className="img-fluid" alt="Elixir" />
                </div>
              </div>
            </Col>
          </Row>
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box4">
                <div className="contactMap-text">
                  <h3>"Trusted Printing with Protected Privacy."</h3>
                </div>
              </div>
            </Col>
            <Col lg={9}>
              <div className="aboutPages-box5">
                <p><strong>Elixir & AR Graphics</strong> places the utmost priority on ensuring compliance with all local laws, regulations, and social responsibilities; consistently abiding by our own high business ethics, which we believe should form the foundation of all our business activities. We firmly believe that observing laws, regulations, and social standards is a primary requisite for any quality international company and is essential for winning and maintaining the trust of both our customers and employees.</p>
                <p>We are, therefore, committed to ensuring our products and services comply with all relevant safety, health, and environmental regulations.</p>
                <p>Our corporate team of professionals—comprising quality engineers and QC inspectors, in addition to social and environmental compliance liaison auditors—work together to help us manage and control our company's social, product, safety, health, and environmental responsibilities.</p>
                <p>To contribute to overall global environmental protection within our markets, <strong>Elixir & AR Graphics</strong> places high priority on initiatives that promote environmental sustainability and encourage high health and safety standards.</p>
                <p>We take pride in the quality of our work, the professionalism we bring to the market, and the strength of our values and practices.</p>
                <p>The Core Values of <strong>Elixir & AR Graphics</strong> are detailed below and define the principles and standards by which our company and its associate companies conduct their business. We continuously remind and educate our employees about their responsibilities, encouraging them to behave in a manner that meets the challenges we face as true professionals in the modern global business environment.</p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
    </>
  );
}

export default Privacypolicy;
